import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import state from "./state";

export default {
  // ejemplo -->  superEjemplo
  state,
  actions,
  getters,
  mutations,
};
